import { render } from "./TestStatistics.vue?vue&type=template&id=944455a4&scoped=true&ts=true"
import script from "./TestStatistics.vue?vue&type=script&lang=ts"
export * from "./TestStatistics.vue?vue&type=script&lang=ts"

import "./TestStatistics.vue?vue&type=style&index=0&id=944455a4&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944455a4"]])

export default __exports__